import { textConstants } from 'constants/texts';
import { useAmplitude } from 'hooks/useAmplitude';
import { useOpenSearchContext } from 'hooks/useOpenSearchContext';
import { useSendTracking } from 'hooks/useSendTracking';
import { TEmptySearchProps } from 'open-search/types';
import { TextsSearchTrucker, benefitsArray } from '../types';

export function useEmptySearch() {
  const { valueInputSearch, isBenefitsModalOpen, openSearchWidth, setIsBenefitsModalOpen } = useOpenSearchContext();
  const { sendAmplitude } = useAmplitude();
  const { sendTrackingJaiminho } = useSendTracking();

  const sendToTrackingInvitationWhatsApp = () => {
    sendAmplitude('trucker_listing_invitation_sent', {
      value: valueInputSearch,
      freightCode: textConstants.notAvailaible,
      type: 'motorista-fora-base',
      source: `convidar-motorista-home`,
    });
    sendTrackingJaiminho(
      {
        nameEvent: 'trucker_listing_invitation_sent',
        data: {
          value: valueInputSearch,
          freightId: textConstants.notAvailaible,
          type: 'motorista-fora-base',
          source: 'convidar-motorista-home',
        },
      },
      'open_search'
    );
  };

  const sendToTrackingBenefits = () => {
    sendAmplitude('trucker_profile_benefits');
    sendTrackingJaiminho(
      {
        nameEvent: 'trucker_profile_benefits',
      },
      'open_search'
    );
  };

  const openWhatsApp = () => {
    sendToTrackingInvitationWhatsApp();
    window.open(TextsSearchTrucker.textWhatsAppUrl, '_blank');
  };

  const propsEmptySearch: TEmptySearchProps = {
    benefitsButtonProps: {
      states: {
        textContent: TextsSearchTrucker.textBenefitsButton,
        textContentMobile: TextsSearchTrucker.textBenefitsButtonMobile,
      },
      events: {
        onClick: () => {
          sendToTrackingBenefits();
          setIsBenefitsModalOpen(true);
        },
      },
    },
    whatsAppButtonProps: {
      states: { textContent: TextsSearchTrucker.textButtonWhatsAppInviteDriver },
      events: {
        onClick: () => openWhatsApp(),
      },
    },
    benefitsModalProps: {
      states: {
        isOpen: isBenefitsModalOpen,
        textTitle: TextsSearchTrucker.textHeaderBenefitsModal,
        whatsAppButtonTextContent: TextsSearchTrucker.textButtonWhatsAppInviteDriver,
        benefits: benefitsArray,
      },
      events: {
        onClose: () => setIsBenefitsModalOpen(false),
        onWhatsAppButtonClick: () => openWhatsApp(),
      },
    },
    openSearchWidth,
  };
  return { propsEmptySearch };
}
